import React from "react";
import { connect } from "react-redux";
import {
  getDocumentCategory,
} from "../../../actions";
import hoistNonReactStatics from 'hoist-non-react-statics'


let loaded = false;

export const withDocumentCategory = (WrapperComponent, documentCat) => {
  class WithDocumentCategory extends React.Component {
    componentDidMount() {
      if (loaded) return;
      loaded = true;
      this.getDocumentCategory();
    }
    getDocumentCategory(documentGrp){
      const { getDocumentCategory } = this.props;
      const group = documentGrp ? { group: documentGrp } : null;
      getDocumentCategory(group);
    }

    getDocumentCategoryOptions = () => undefined

    getDocumentCategoryLocaleOptions = () => {
      const { documentCategory } = this.props;
      return documentCategory.map(({ created_at, ...rest }) => ({ ...rest }));
    }
    render() {
      return (
        <WrapperComponent 
          {...this.props} 
          documentCategoryOptions={this.getDocumentCategoryOptions()} 
          documentCategoryLocaleOptions={this.getDocumentCategoryLocaleOptions()} 
          getDocumentCategory={this.getDocumentCategory}
        />
      )
    }
  }
  const mapStateToProps = ({ documentCategory }) => ({ documentCategory })
  const WithDocumentCategoryHOC = connect(mapStateToProps, {
    getDocumentCategory,
  })(WithDocumentCategory);
  hoistNonReactStatics(WithDocumentCategoryHOC, WrapperComponent)
  return WithDocumentCategoryHOC
}
